/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Fix ANYScript

import { toTypedSchema } from '@vee-validate/zod';
import { type TypedSchema } from 'vee-validate';

export const validateSchema = (zodConfig: any): TypedSchema<any, any> => {
  const validationSchema = toTypedSchema(zodConfig);

  return validationSchema;
};
